// @flow

import React from 'react';
import { Redirect } from 'react-router-dom';

import usePath from '../usePath';
import useScrollToTop from '../useScrollToTop';
import useSelfEnrollment from '../../../hooks/useSelfEnrollment';
import PageHeader from '../PageHeader';
import PhoneForm from './PhoneForm';
import AccountExists from './AccountExists';
import PageButtons from '../PageButtons';
import useContactNumber from '../useContactNumber';
import { MESSAGES, PATHS, SCENARIOS } from '../constants';

import styles from './styles.module.scss';

const FoundPatient = () => {
  useScrollToTop();
  const getPath = usePath();
  const { message, patientData, entityData } = useSelfEnrollment();
  const phoneNumber = useContactNumber();

  if (!message) {
    return <Redirect to={getPath(PATHS.IDENTIFY)} />;
  }

  const name = patientData?.name ?? '';
  const cobrandedLink = entityData?.selfEnrollment?.selfEnrollmentCobrandedLink;

  if (message === MESSAGES.PATIENT_FOUND) {
    return <AccountExists />;
  }

  return (
    <div className={styles.container}>
      <PageHeader
        headerId="app.self-enroll.found.eligible.header"
        subHeaderId="app.self-enroll.found.eligible.sub-header"
        values={{ name }}
        headerVariant="d2"
      />
      <PhoneForm className={styles.phoneForm} />
      <div className={styles.pageButtonsWrapper}>
        <PageButtons scenario={SCENARIOS.IDENTIFY} cobrandedLink={cobrandedLink} phoneNumber={phoneNumber} />
      </div>
    </div>
  );
};

export default FoundPatient;
